import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon'

export interface TriGridProps {
  onFreePlay?: () => void
  onLeaderboards?: () => void
  onHistory?: () => void
}

export function TriGrid({ onFreePlay, onLeaderboards, onHistory }: TriGridProps) {
  const { t } = useTranslation()

  const cells = [
    { icon: <Icon name="target" size={22} />, label: t('lobby.tri.freeplay'), onClick: onFreePlay },
    { icon: <Icon name="chart" size={22} />, label: t('lobby.tri.leaderboards'), onClick: onLeaderboards },
    { icon: <Icon name="history" size={22} />, label: t('lobby.tri.history'), onClick: onHistory },
  ]

  return (
    <div className="tri-grid">
      {cells.map((cell) => (
        <div
          key={cell.label}
          className="tri-cell"
          onClick={cell.onClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') cell.onClick?.()
          }}
        >
          <span className="icon">{cell.icon}</span>
          <span className="lbl">{cell.label}</span>
        </div>
      ))}
    </div>
  )
}
